<template>
  <div>
    <div class="tabsNotes">
      <div class="dates-wrap">
        <h5 class="dates"></h5>
      </div>
      <div class="accordion-wrap">
        <div v-for="(note, index) in leadNotes" :key="note.id">
          <div :id="'accordion' + index">
            <div class="card mb-3">
              <div class="card-header" :id="'headingThree' + index">
                <h5 class="mb-0">
                  <div class="accordion-header">
                    <button
                        class="btn btn-link collapsed"
                        @click="toggleAccordion(index)"
                        :aria-expanded="activeIndex === index"
                        :aria-controls="'collapseThree' + index"
                    >
                      <div class="container-fluid accordion-button-content">
                        <div class="accordion-heading-wrap">
                          <div class="accordion-arrow-wrap">
                            <h5 class="accordion-heading">
                              <i :class="activeIndex === index ? 'fas fa-chevron-down' : 'fas fa-chevron-right'" class="accordion-arrow"></i>
                              <b>{{ note.user.first_name }} {{ note.user.last_name }}</b> added note
                            </h5>
                            <h5 class="accordion-para" :class="{ 'd-none': activeIndex === index }" v-html="note.comment && note.comment.length > 100 ? `${note.comment.substring(0, 150)}...` : note.comment"></h5>
                          </div>
                          <div class="accordion-time-wrap">
                            <div class="accordion-time">
                              <h5 class="time-span">{{ note.created_at }}</h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </div>
                  <div
                      :id="'collapseThree' + index"
                      class="collapse"
                      :class="{ show: activeIndex === index }"
                      :aria-labelledby="'collapseThree' + index"
                      :data-parent="'#accordion' + index"
                  >
                    <div class="card-body pl-3" v-html="note.comment"></div>
                  </div>
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pencilEdit from "@/assets/images/pencil-edit.svg";
import editIcon from "@/assets/images/edit2.svg";
import deleteIcon from "@/assets/images/delete.svg";
import {flatMap} from "lodash/collection";
import supportComment from "@/components/support/support_comment.vue";

export default {
  name: "NotesTab",
  props: {
    showCreateNote: {
      type: Function,
      required: true,
    },
    leadNotes: [],
    customerDetail: []
  },
  data() {
    return {
      activeMenuId: null,
      deleteIcon: deleteIcon,
      editIcon: editIcon,
      pencilEdit: pencilEdit,
      activeIndex: null,
    };
  },

  mounted() {

  },

  methods: {

    toggleAccordion(index) {
      this.activeIndex = this.activeIndex === index ? null : index;
    },
    flatMap,
    toggleMenu(menuId) {
      this.activeMenuId = this.activeMenuId === menuId ? null : menuId;
    },

  }
};


</script>
